module.exports = __webpack_public_path__ + "static/media/modulo-pesquisa.abaa5c47.svg";